"use strict";
'use client';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = MessageSection;
exports.validateMessageType = void 0;
var _react = _interopRequireDefault(require("react"));
var _server = _interopRequireDefault(require("react-dom/server"));
var _message = _interopRequireDefault(require("../message/message"));
var _pageSection = _interopRequireDefault(require("../pageSection/pageSection"));
var _messageSectionModule = _interopRequireDefault(require("./messageSection.module.scss"));
var _classnames = _interopRequireDefault(require("classnames"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var validateMessageType = exports.validateMessageType = function validateMessageType(type) {
  switch (type === null || type === void 0 ? void 0 : type.toLowerCase()) {
    case 'error':
      return 'error';
    case 'success':
      return 'success';
    case 'warning':
      return 'warning';
    case 'jlm neon green':
      return 'jlm-neon-green';
    case 'jlm light blue':
      return 'jlm-light-blue';
    case 'jlm light green':
      return 'jlm-light-green';
    default:
      return 'information';
  }
};
function MessageSection(_ref) {
  var copy = _ref.copy,
    title = _ref.title,
    icon = _ref.icon,
    type = _ref.type,
    spacingAbove = _ref.spacingAbove,
    spacingBelow = _ref.spacingBelow;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_pageSection["default"], {
    className: _messageSectionModule["default"].pageSection,
    innerContainerClassName: (0, _classnames["default"])(_messageSectionModule["default"].innerContainer, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, _messageSectionModule["default"].spacingAboveNone, spacingAbove === 'none'), _messageSectionModule["default"].spacingAboveMedium, spacingAbove === 'medium'), _messageSectionModule["default"].spacingAboveLarge, spacingAbove === 'large'), _messageSectionModule["default"].spacingBelowNone, spacingBelow === 'none'), _messageSectionModule["default"].spacingBelowMedium, spacingBelow === 'medium'), _messageSectionModule["default"].spacingBelowLarge, spacingBelow === 'large')),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_message["default"], {
      title: title,
      htmlContent: copy ? _server["default"].renderToString(copy) : '',
      type: validateMessageType(type),
      icon: icon
    })
  });
}